// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/result/index.less
// module id = 96
// module chunks = 0